import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';

export type InventoryViewMode = 'superviseur' | 'inventoriste';

export interface InventoryViewModeContextValue {
  viewMode: InventoryViewMode;
  setViewMode: (mode: InventoryViewMode) => void;
  /** POC : toujours true. Plus tard, false si le rôle utilisateur impose une seule vue. */
  isViewModeSwitchVisible: boolean;
}

const InventoryViewModeContext = createContext<InventoryViewModeContextValue | null>(null);

interface InventoryViewModeProviderProps {
  children: React.ReactNode;
}

export const InventoryViewModeProvider = ({ children }: InventoryViewModeProviderProps) => {
  const [viewMode, setViewModeState] = useState<InventoryViewMode>('superviseur');

  const setViewMode = useCallback((mode: InventoryViewMode) => {
    setViewModeState(mode);
  }, []);

  const value = useMemo(
    () => ({
      viewMode,
      setViewMode,
      isViewModeSwitchVisible: true,
    }),
    [viewMode, setViewMode],
  );

  return (
    <InventoryViewModeContext.Provider value={value}>{children}</InventoryViewModeContext.Provider>
  );
};

export function useInventoryViewMode(): InventoryViewModeContextValue {
  const context = useContext(InventoryViewModeContext);

  if (!context) {
    throw new Error('useInventoryViewMode doit être utilisé sous InventoryViewModeProvider');
  }

  return context;
}
